import React from 'react';

/**
 * Loads the agency's own typeface from Google Fonts, once per page, and gives
 * back the font stack to set: the typeface first, ours behind it while it loads
 * or if it never does. Empty: ours alone (undefined, so nothing is overridden).
 */
export function useWebFont(family: string | undefined, ours: string | undefined): string | undefined {
  const name = (family || '').trim();
  React.useEffect(() => {
    if (!name || !/^[A-Za-z0-9 ]{1,40}$/.test(name)) return;
    const id = `wa-font-${name.replace(/ /g, '-')}`;
    if (document.getElementById(id)) return;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(name)}:wght@400;500;600;700&display=swap`;
    document.head.appendChild(link);
  }, [name]);
  return name ? `"${name}", ${ours || 'sans-serif'}` : undefined;
}

/** sx that sets a typeface on everything inside, MUI's own text included. */
export const withFont = (stack: string | undefined) => (stack ? {
  fontFamily: stack,
  '& .MuiTypography-root, & .MuiInputBase-root, & .MuiButtonBase-root': { fontFamily: stack },
} : {});
